import React, { useState } from 'react';
import './FindBuyerModal.css';

const FindBuyerModal = ({ isOpen, onClose, onSave }) => {
  const [tagline, setTagline] = useState('');

  if (!isOpen) return null;

  const handleCancel = () => {
    setTagline('');
    onClose();
  };

  const handleSave = () => {
    if (onSave) {
      onSave({
        tagline: tagline
      });
    }
    setTagline('');
    onClose();
  };

  return (
    <div className="find-buyer-modal-overlay" onClick={onClose}>
      <div className="find-buyer-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="find-buyer-modal-header">
          <h2 className="find-buyer-modal-title">Find Buyer</h2>
        </div>

        <div className="find-buyer-modal-content">
          <div className="find-buyer-form-section">
            <div className="find-buyer-input-group">
              <label className="find-buyer-input-label">Write Tagline</label>
              <div className="find-buyer-input-wrapper">
                <input
                  type="text"
                  className="find-buyer-input"
                  placeholder="Write Tagline"
                  value={tagline}
                  onChange={(e) => setTagline(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="find-buyer-modal-actions">
            <button className="find-buyer-cancel-btn" onClick={handleCancel}>
              Cancel
            </button>
            <button className="find-buyer-save-btn" onClick={handleSave}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindBuyerModal;
